module.exports = __webpack_public_path__ + "img/big6-2.7b30d511.jpg";